import styles from './ThreeColumnGrid.module.css';
import GitHubLogo from './GitHubLogo.jsx';
import ArrowDown from '../assets/ArrowDown.jsx';
import { useState, useContext } from 'react';
import { useParams } from "react-router-dom";
import { SmootherContext } from '../components/common/SmootherContext.js';

function ThreeColumnGrid({ title, items }) {

    // getting the smooth scroll context to refresh when see more is clicked
    const smoother = useContext(SmootherContext);

    // get the current lang for routing
    const { lang } = useParams();

    const [visibleItems, setVisibleItems] = useState(3);
    const itemsPerPage = 6;

    const handleSeeMore = () => {
        setVisibleItems(prev => prev + itemsPerPage);
        smoother.refresh();
    };

    if (!items) return;

    // Get only the visible items
    const displayedItems = items.slice(0, visibleItems);

    // Check if there are more items to show
    const hasMoreItems = visibleItems < items.length;

    return (
        <div className={styles.threeColGrid}>
            <h2>{title}</h2>
            <div className={styles.grid}>
                {displayedItems.map((item, i) => {

                    const getMediaType = (url) => {
                        if (!url) return null;
                        const extension = url.split('.').pop().toLowerCase();
                        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
                        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

                        if (videoExtensions.includes(extension)) return 'video';
                        if (imageExtensions.includes(extension)) return 'image';
                        return null;
                    };

                    const mediaType = getMediaType(item.fields.media.fields.file.url);

                    const picURL = item.fields.media.fields.file.url
                    return (
                        <div className={styles.lab_item} key={i}>
                            <div className={styles.mediawrap}>
                                {mediaType === "video" && (
                                    <video className={styles.video} autoPlay playsInline loop muted>
                                        <source src={item.fields.media.fields.file.url} type="video/mp4" />
                                    </video>
                                )}

                                {mediaType === "image" && (
                                    <picture>
                                        <source
                                            srcSet={`
                                                ${picURL}?w=500 500w, 
                                                ${picURL}?w=1000 1000w, 
                                                ${picURL}?w=2000 2000w`
                                            }
                                            sizes="(max-width: 600px) 100vw, 33vw"
                                        />
                                        <img
                                            className={styles.image}
                                            src={`${picURL}?w=1000`}
                                            alt={item.fields.title}
                                        />
                                    </picture>


                                )}
                            </div>
                            <h3>{item.fields.title}</h3>
                            <div className={styles.content}>
                                <p>{item.fields.description}</p>
                                <div className={styles.links}>
                                    {item.fields.whitePaperLink && (
                                        <a href={item.fields.whitePaperLink}>{lang === "ko" ? "기술 백서" : "White Paper"} <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.3327 1.33325H3.99935C3.38051 1.33325 2.78702 1.57908 2.34943 2.01667C1.91185 2.45425 1.66602 3.04775 1.66602 3.66659V22.3333C1.66602 22.9521 1.91185 23.5456 2.34943 23.9832C2.78702 24.4208 3.38051 24.6666 3.99935 24.6666H17.9994C18.6182 24.6666 19.2117 24.4208 19.6493 23.9832C20.0869 23.5456 20.3327 22.9521 20.3327 22.3333V8.33325M13.3327 1.33325L20.3327 8.33325M13.3327 1.33325V8.33325H20.3327M15.666 14.1666H6.33268M15.666 18.8333H6.33268M8.66602 9.49992H6.33268" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        </a>
                                    )}
                                    {item.fields.gitHubLink && (
                                        <a href={item.fields.gitHubLink}>GitHub
                                            <GitHubLogo />
                                        </a>
                                    )}
                                </div>
                            </div>

                        </div>
                    );
                })}


            </div>

            {hasMoreItems && (
                <button className="see_more" onClick={handleSeeMore}>
                    {lang === "ko" ? "모두 보기" : "SEE MORE"} <ArrowDown />
                </button>
            )}
        </div>
    );
}

export default ThreeColumnGrid;
